import React, { useState, useEffect } from "react";
import { LANDING } from "@/constants/testIds";
import { Menu, X } from "lucide-react";

export default function PillNav() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 30);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const scrollTo = (id) => {
    document.getElementById(id)?.scrollIntoView({ behavior: "smooth", block: "start" });
    setOpen(false);
  };

  return (
    <div className="fixed top-12 left-0 right-0 z-50 flex justify-center px-4 pointer-events-none">
      <div
        className={`pill-nav-shell pointer-events-auto flex items-center gap-1 px-2 py-2 transition-all duration-300 ${
          scrolled ? "shadow-xl top-3" : ""
        }`}
      >
        <button
          data-testid={LANDING.navLogo}
          onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
          className="flex items-center px-2 py-0"
          aria-label="Dubai Pillows"
        >
          <img
            src="/assets/dubai_logo_black.png"
            alt="Dubai Pillows"
            className="h-12 md:h-14 w-auto"
          />
        </button>

        <div className="hidden md:flex items-center gap-0.5 mx-2">
          <button
            data-testid={LANDING.navShop}
            onClick={() => scrollTo("shop")}
            className="px-4 py-2 text-[14px] font-medium text-[#2a2a2e] hover:bg-black/5 rounded-full transition-colors"
          >
            Shop
          </button>
          <button
            data-testid={LANDING.navHow}
            onClick={() => scrollTo("how")}
            className="px-4 py-2 text-[14px] font-medium text-[#2a2a2e] hover:bg-black/5 rounded-full transition-colors"
          >
            How It Works
          </button>
          <button
            data-testid={LANDING.navReviews}
            onClick={() => scrollTo("reviews")}
            className="px-4 py-2 text-[14px] font-medium text-[#2a2a2e] hover:bg-black/5 rounded-full transition-colors"
          >
            Reviews
          </button>
          <button
            data-testid={LANDING.navFaq}
            onClick={() => scrollTo("faq")}
            className="px-4 py-2 text-[14px] font-medium text-[#2a2a2e] hover:bg-black/5 rounded-full transition-colors"
          >
            FAQ
          </button>
        </div>

        <button
          data-testid={LANDING.navCta}
          onClick={() => scrollTo("shop")}
          className="hidden md:inline-flex pill-btn text-[13px] py-2.5 px-5"
        >
          See the pillow →
        </button>

        <button
          className="md:hidden p-2.5 rounded-full hover:bg-black/5"
          onClick={() => setOpen((v) => !v)}
          aria-label="Toggle menu"
        >
          {open ? <X size={18} /> : <Menu size={18} />}
        </button>
      </div>

      {open && (
        <div className="md:hidden absolute top-20 left-4 right-4 bg-white rounded-3xl shadow-2xl p-6 pointer-events-auto border border-black/5">
          <div className="flex flex-col gap-1">
            <button onClick={() => scrollTo("shop")} className="text-left py-3 font-medium">
              Shop
            </button>
            <button onClick={() => scrollTo("how")} className="text-left py-3 font-medium border-t border-[#ececec]">
              How It Works
            </button>
            <button onClick={() => scrollTo("reviews")} className="text-left py-3 font-medium border-t border-[#ececec]">
              Reviews
            </button>
            <button onClick={() => scrollTo("faq")} className="text-left py-3 font-medium border-t border-[#ececec]">
              FAQ
            </button>
            <button onClick={() => scrollTo("shop")} className="pill-btn mt-4 w-full">
              See the pillow →
            </button>
          </div>
        </div>
      )}
    </div>
  );
}
